import React from "react";
import Typography from '@visa/vds/typography';
import Icon from '@visa/vds/icon';
import InlineNote from '@visa/vds/inline-note';
import InlineNoteIcon from '@visa/vds/inline-note-icon';

const CertificationWorkflowUnselectedUserNote = (props) => {
    return (
        <InlineNote noteType="info">
            <InlineNoteIcon>
                <Icon name="info" resolution="tiny" />
            </InlineNoteIcon>
            <Typography>{props.note}</Typography>
        </InlineNote>
    );
};

export default CertificationWorkflowUnselectedUserNote;
